import * as r from "react";
import f from "react";
import { S as w, g as O, m as N, q as S, a as P } from "./index-CjjiqU7h.mjs";
import { t as D } from "./toArray-C1Af_up9.mjs";
const L = (e) => {
  const t = f.useContext(w);
  return f.useMemo(() => e ? typeof e == "string" ? e ?? t : e instanceof Function ? e(t) : t : t, [e, t]);
}, M = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      "&-block": {
        display: "flex",
        width: "100%"
      },
      "&-vertical": {
        flexDirection: "column"
      }
    }
  };
}, j = (e) => {
  const {
    componentCls: t,
    antCls: a
  } = e;
  return {
    [t]: {
      display: "inline-flex",
      "&-rtl": {
        direction: "rtl"
      },
      "&-vertical": {
        flexDirection: "column"
      },
      "&-align": {
        flexDirection: "column",
        "&-center": {
          alignItems: "center"
        },
        "&-start": {
          alignItems: "flex-start"
        },
        "&-end": {
          alignItems: "flex-end"
        },
        "&-baseline": {
          alignItems: "baseline"
        }
      },
      [`${t}-item:empty`]: {
        display: "none"
      },
      // https://github.com/ant-design/ant-design/issues/47875
      [`${t}-item > ${a}-badge-not-a-wrapper:only-child`]: {
        display: "block"
      }
    }
  };
}, E = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      "&-gap-row-small": {
        rowGap: e.spaceGapSmallSize
      },
      "&-gap-row-middle": {
        rowGap: e.spaceGapMiddleSize
      },
      "&-gap-row-large": {
        rowGap: e.spaceGapLargeSize
      },
      "&-gap-col-small": {
        columnGap: e.spaceGapSmallSize
      },
      "&-gap-col-middle": {
        columnGap: e.spaceGapMiddleSize
      },
      "&-gap-col-large": {
        columnGap: e.spaceGapLargeSize
      }
    }
  };
}, _ = O("Space", (e) => {
  const t = N(e, {
    spaceGapSmallSize: e.paddingXS,
    spaceGapMiddleSize: e.padding,
    spaceGapLargeSize: e.paddingLG
  });
  return [j(t), E(t), M(t)];
}, () => ({}), {
  // Space component don't apply extra font style
  // https://github.com/ant-design/ant-design/issues/40315
  resetStyle: !1
});
var C = function(e, t) {
  var a = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (a[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (a[n[o]] = e[n[o]]);
  return a;
};
const m = /* @__PURE__ */ r.createContext(null), A = (e, t) => {
  const a = r.useContext(m), n = r.useMemo(() => {
    if (!a)
      return "";
    const {
      compactDirection: o,
      isFirstItem: d,
      isLastItem: u
    } = a, l = o === "vertical" ? "-vertical-" : "-";
    return S(`${e}-compact${l}item`, {
      [`${e}-compact${l}first-item`]: d,
      [`${e}-compact${l}last-item`]: u,
      [`${e}-compact${l}item-rtl`]: t === "rtl"
    });
  }, [e, t, a]);
  return {
    compactSize: a == null ? void 0 : a.compactSize,
    compactDirection: a == null ? void 0 : a.compactDirection,
    compactItemClassnames: n
  };
}, H = (e) => {
  let {
    children: t
  } = e;
  return /* @__PURE__ */ r.createElement(m.Provider, {
    value: null
  }, t);
}, F = (e) => {
  var {
    children: t
  } = e, a = C(e, ["children"]);
  return /* @__PURE__ */ r.createElement(m.Provider, {
    value: a
  }, t);
}, T = (e) => {
  const {
    getPrefixCls: t,
    direction: a
  } = r.useContext(P), {
    size: n,
    direction: o,
    block: d,
    prefixCls: u,
    className: l,
    rootClassName: v,
    children: y
  } = e, x = C(e, ["size", "direction", "block", "prefixCls", "className", "rootClassName", "children"]), I = L((i) => n ?? i), s = t("space-compact", u), [b, G] = _(s), $ = S(s, G, {
    [`${s}-rtl`]: a === "rtl",
    [`${s}-block`]: d,
    [`${s}-vertical`]: o === "vertical"
  }, l, v), c = r.useContext(m), p = D(y), z = r.useMemo(() => p.map((i, g) => {
    const h = (i == null ? void 0 : i.key) || `${s}-item-${g}`;
    return /* @__PURE__ */ r.createElement(F, {
      key: h,
      compactSize: I,
      compactDirection: o,
      isFirstItem: g === 0 && (!c || (c == null ? void 0 : c.isFirstItem)),
      isLastItem: g === p.length - 1 && (!c || (c == null ? void 0 : c.isLastItem))
    }, i);
  }), [n, p, c]);
  return p.length === 0 ? null : b(/* @__PURE__ */ r.createElement("div", Object.assign({
    className: $
  }, x), z));
};
export {
  T as C,
  H as N,
  A as a,
  _ as b,
  L as u
};
//# sourceMappingURL=Compact-8zmhZt2C.mjs.map
